import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth' // Using custom hook

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth() // Using custom hook instead of useSelector
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default ProtectedRoute
